// Librerías
import React from 'react';
// Components
import CheckoutComponentMobile from '../components/Confirmed/ConfirmedComponentMobile';

const ConfirmedContainerMobile = () => {
  return(
    <React.Fragment>
      <CheckoutComponentMobile />
    </React.Fragment>
  )
}

export default ConfirmedContainerMobile;